export interface AccordianItem {
  id: number;
  ques: string;
  ans: string;
}
export const accordianList: AccordianItem[] = [
  {
    id: 1,
    ques: "Is Resumemate free to use?",
    ans: "Yes, Resumemate is free to use for creating and customizing resumes. However, the AI Recommendation System is available as a paid feature.",
  },
  {
    id: 2,
    ques: "What makes Resumemate different?",
    ans: "Resumemate is a no-nonsense resume builder with a clean interface, offering real-time tracking of views on the resumes you share.",
  },
  {
    id: 3,
    ques: "Can I upload an existing resume for editing?",
    ans: "Yes, you can upload an existing resume in PDF format, and Resumemate will allow you to edit and enhance it using its features.",
  },
  {
    id: 4,
    ques: "What does ‘ATS-friendly’ mean?",
    ans: "‘ATS-friendly’ means that your resume is optimized to be easily read by Applicant Tracking Systems. Resumemate uses ATS-friendly templates and AI recommendations to ensure your resume stands out.",
  },
  {
    id: 5,
    ques: "What are the sharing options?",
    ans: "You can download your resume as a PDF or share it via a unique link.",
  },
  {
    id: 6,
    ques: "Can I make my resume private?",
    ans: "Yes, you can set your resume's sharing option to private, ensuring the sharing link becomes inactive and your resume remains accessible only to you.",
  },
];
